import { Action } from '@ngrx/store';
import { TableState } from '../../../shared/components/asset-data-table/asset-data-table.helpers';
import { SortObject, TableFilterObject } from '../types';

export const SORT_SUB_GROUP_ASSET_LIST = '[Sub Group View] Sort Sub Group Asset List';
export const FILTER_SUB_GROUP_ASSET_LIST = '[Sub Group View] Filter Sub Group Asset List';
export const LIST_TABLE_STATE = '[Sub Group View] List Table State';
export const LIST_TABLE_STATE_COMPLETE = '[Sub Group View] List Table State Complete';

export class SortSubGroupAssetsAction implements Action {
    readonly type = SORT_SUB_GROUP_ASSET_LIST;

    constructor(public payload: { subGroupId: number, sort: SortObject }) { }
}

export class FilterSubGroupAssetsAction implements Action {
    readonly type = FILTER_SUB_GROUP_ASSET_LIST;

    constructor(public payload: { subGroupId: number, filter: TableFilterObject, reset?: boolean }) { }
}

export class ListTableStateAction implements Action {
    readonly type = LIST_TABLE_STATE;

    constructor(public payload: { subGroupId: number, stateKey: string }) { }
}

export class ListTableStateCompleteAction implements Action {
    readonly type = LIST_TABLE_STATE_COMPLETE;

    constructor(public payload: { subGroupId: number, tableState: TableState }) { }
}

export type Actions
    = SortSubGroupAssetsAction
    | FilterSubGroupAssetsAction
    | ListTableStateAction
    | ListTableStateCompleteAction;
